var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export var FlexRow = function (_a) {
    var children = _a.children, flex = _a.flex, style = _a.style, _b = _a.className, className = _b === void 0 ? '' : _b, onClick = _a.onClick;
    return React.createElement('div', { className: "patterns-flex-row " + className, style: __assign(__assign({}, style), { flex: flex }), onClick: onClick }, children);
};
export var FlexColumn = function (_a) {
    var children = _a.children, flex = _a.flex, style = _a.style, _b = _a.className, className = _b === void 0 ? '' : _b, onClick = _a.onClick;
    return React.createElement('div', { className: "patterns-flex-column " + className, style: __assign(__assign({}, style), { flex: flex }), onClick: onClick }, children);
};
export var Toolbar = function (_a) {
    var children = _a.children, style = _a.style, _b = _a.className, className = _b === void 0 ? '' : _b;
    return React.createElement('div', { className: "patterns-toolbar " + className, style: style }, children);
};
export var Panel = function (_a) {
    var children = _a.children, style = _a.style, _b = _a.className, className = _b === void 0 ? '' : _b;
    return React.createElement('div', { className: "patterns-panel " + className, style: style }, children);
};
//# sourceMappingURL=components.js.map